module.exports = __webpack_public_path__ + "img/DE00569.739bcfe8.png";